import axios from "@/providers/requests";
import ENDPOINTS from "@/providers/end-points";

import { Translate as $t } from "@/plugins/translate";

const state = {
  cites: [],
  areas: [],
  success: false,
  message: null,
};

export default {
  namespaced: true,
  state,

  getters: {
    cites: (state: any) => state.cites,
    areas: (state: any) => state.areas,
    result: (state: any) => ({
      success: state.success,
      message: state.message,
    }),
  },

  mutations: {
    SET_DATA_RESULT(state: any, payload) {
      state.success = payload.success;
      state.message = payload.message;
    },
  },

  actions: {
    /**
     * Set Available Locations
     * @param commit
     * @param data
     */
    async setAvailableBranches({ commit }: { commit: any }, data: any) {
      return await axios
        .put(ENDPOINTS.LOCATION_BY_AREA, data)
        .then((response) => response.data)
        .then(async ({ data }) => {
          await commit("SET_DATA_RESULT", {
            success: true,
            message: data?.message || $t("saved_successfully"),
          });
        })
        .catch(async (error) => {
          await commit("SET_DATA_RESULT", { success: false, message: error?.message || $t("something_went_wrong") });
        });
    },

    /**
     * Set Default Locations
     * @param commit
     * @param payload
     */
    async setDefaultLocation({ commit }: { commit: any }, payload: any) {
      return await axios
        .put(ENDPOINTS.DEFAULT_LOCATION_BY_AREA(payload.locationId), payload.data)
        .then((response) => response.data)
        .then(async ({ data }) => {
          await commit("SET_DATA_RESULT", {
            success: true,
            message: data?.message || $t("saved_successfully"),
          });
        })
        .catch(async (error) => {
          await commit("SET_DATA_RESULT", { success: false, message: error?.message || $t("something_went_wrong") });
        });
    },

    /**
     * Set Business Default Locations
     * @param commit
     * @param payload
     */
    async setBusinessDefaultLocation({ commit }: { commit: any }, payload: any) {
      return await axios
        .post(ENDPOINTS.DEFAULT_LOCATION(payload.locationId))
        .then((response) => response.data)
        .then(async ({ data }) => {
          await commit("SET_DATA_RESULT", {
            success: true,
            message: data?.message || $t("saved_successfully"),
          });
        })
        .catch(async ({ error }) => {
          await commit("SET_DATA_RESULT", { success: false, message: error?.message || $t("something_went_wrong") });
        });
    },
  },
};
